import { useEffect, useState } from 'react'
import {
  REVOKE_MFA_CONFIRM,
  REVOKE_MFA_FORM_LABEL,
  REVOKE_MFA_FORM_PLACEHOLDER,
  REVOKE_MFA_GENERIC_ERROR,
  REVOKE_MFA_LAST_OPTION_SUBTITLE,
  REVOKE_MFA_TITLE,
} from '../../constants/ui.labels'
import { SETTINGS_PAGE } from '../../constants/links'
import { navigateTo } from '../../utils/redirect/navigator'
import { Properties, RECOVERY_OTP } from '../../constants/mfa'
import { DisableMFAForm } from '../../components'
import { ContentHeader, Error } from 'mfa'
import mapError from '../../utils/mapError/mfa'
import Flex from '@talkdesk/cobalt-react-flex'

const DisableMFA = ({
  onRevokeAllMFAMechanisms,
  onRevokeMFAMechanism,
  onExecuteRecaptcha,
  isLastMFAMechanism,
  mfaToRevoke,
  isMFARevokeInProgress,
  isSuccessfullyRevoked,
  revokeMFAErrorCode = null,
  siteKey,
}) => {
  const [password, setPassword] = useState('')

  const handleRevokeMfaConfirm = (recaptchaResponse) => {
    if (isLastMFAMechanism || mfaToRevoke === RECOVERY_OTP) {
      onRevokeAllMFAMechanisms({
        password,
        recaptchaResponse,
      })
    } else {
      onRevokeMFAMechanism({
        mfaMechanism: mfaToRevoke,
        password,
        recaptchaResponse,
      })
    }
  }

  useEffect(() => {
    if (isSuccessfullyRevoked) {
      navigateTo(SETTINGS_PAGE)
    }
  }, [isSuccessfullyRevoked])

  if (isSuccessfullyRevoked) {
    return null
  }

  const isFormValid = password !== ''
  const errorMessage =
    revokeMFAErrorCode && mapError(revokeMFAErrorCode, REVOKE_MFA_GENERIC_ERROR)
  const mfaName = Properties[mfaToRevoke].name
  const title = REVOKE_MFA_TITLE(mfaName)
  const subtitle =
    isLastMFAMechanism && mfaToRevoke !== RECOVERY_OTP
      ? REVOKE_MFA_LAST_OPTION_SUBTITLE(mfaName)
      : ''

  return (
    <Flex direction='column' gap='4'>
      <ContentHeader title={title} message={subtitle} />
      <Error message={errorMessage} />
      <DisableMFAForm
        onFormChange={setPassword}
        onConfirm={handleRevokeMfaConfirm}
        onExecuteRecaptcha={onExecuteRecaptcha}
        confirmText={REVOKE_MFA_CONFIRM}
        formLabel={REVOKE_MFA_FORM_LABEL}
        formPlaceholder={REVOKE_MFA_FORM_PLACEHOLDER}
        isMFARevokeInProgress={isMFARevokeInProgress}
        isFormValid={isFormValid}
        siteKey={siteKey}
      />
    </Flex>
  )
}

export default DisableMFA
